<template>
    <div class="div-half">
        <button type="button" @click="showModal = true" class="btn btn-sm btn-grey btn-grey--outline">Empty basket</button>
        <modal-dialog classes="modal--centered" title="Are you sure?" :show="showModal" @close="showModal = false">
            <div class="text-center">
                <p>This action will empty all products from your basket</p>
                <hr>
                <div class="row">
                    <div class="col-md-6">
                        <button class="btn btn-sm btn--full-width btn-red" @click="clearBasket">Empty Basket</button>
                    </div>
                    <div class="col-md-6">
                        <button class="btn btn-sm btn--full-width btn-grey" @click="showModal = false">Cancel</button>
                    </div>
                </div>
            </div>
        </modal-dialog>
    </div>
</template>

<script>
    import ModalDialog from '../Elements/ModalDialog.vue';
    import Basket from '../../Services/Basket.js';

    export default {
        components: {
            ModalDialog
        },
        data() {
            return {
                showModal: false,
            }
        },
        methods: {
            clearBasket() {
                Basket.setLines([]).then(response => {
                    location.reload();
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Basket/EmptyBasket.vue